import React, { useEffect, useState } from 'react';
import Sidebar from '../Sidebar';
import Clients from './Clients'; // ✅ default import
import FetchUserDetails from '../../components/UserDetails/FetchUserDetails';
import './Clients.css';

const ClientHome = () => {
  const [isGetUserDetailsFunctionExecuted, setIsGetUserDetailsFunctionExecuted] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    const savedState = sessionStorage.getItem('isSidebarCollapsed');
    return savedState ? JSON.parse(savedState) : false;
  });

  useEffect(() => {
    sessionStorage.setItem('isSidebarCollapsed', JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  const handleToggleSidebar = () => {
    setIsSidebarCollapsed(prev => !prev);
  };

  useEffect(() => {
    const getUserDetails = async () => {
      try {
        if (
          sessionStorage.getItem('user_name') &&
          sessionStorage.getItem('user_emailId') &&
          sessionStorage.getItem('user_id')
        ) {
          setIsGetUserDetailsFunctionExecuted(true);
          return;
        }
        await FetchUserDetails();
      } catch (error) {
        console.error('Error fetching user details:', error);
      } finally {
        setIsGetUserDetailsFunctionExecuted(true);
      }
    };
    getUserDetails();
  }, []);

  if (!isGetUserDetailsFunctionExecuted) return null;

  return (
    <div className="clients-home-container">
      <Sidebar onToggleSidebar={handleToggleSidebar} isCollapsed={isSidebarCollapsed} />
      <div className={`clients-home-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <Clients />
      </div>
    </div>
  );
};

export default ClientHome;
